import React from "react";
import { createContext, useState } from "react"

// VideosPopupContext передает данные между VideoPopup и VideosPreview
// о том какое видео должно быть открыто, 
// и не дает открыть более одного попапа за раз

const closedState = {
    isPopupShown: false,
    popupProps: {
        VideoId: "", 
        VideoTitle: "",
        VideoImageUrl: "",
        VideoDescription: ""
    }
}

export const VideosPopupContext = createContext(closedState);

export function VideosPopupProvider({ children }) {

    const [popupState, setPopupState] = useState(closedState)

    const closePopup = () => {
        setPopupState(closedState)
    }
    const openPopup = (videoId, videoTitle, videoImageUrl, videoDescription) => {
        setPopupState({
            isPopupShown: true,
            popupProps: {
                VideoId: videoId, 
                VideoTitle: videoTitle,
                VideoImageUrl: videoImageUrl,
                VideoDescription: videoDescription
            }
        })
    }

    return (
        <VideosPopupContext.Provider value={{ popupState, closePopup, openPopup}}>
            {children}
        </VideosPopupContext.Provider>
    )
}


